import React from "react";
import { SRLWrapper } from "simple-react-lightbox";

export const Sony = () => {
  let pictures = [];
  for (let i = 1; i <= 5; i++) {
    pictures.push(
      require(`../../../Assets/img/photos/commissions/sony-alpha/sony-alpha-${i}.jpg`)
    );
  }
  return (
    <div className="commissions-content">
      <p className="commissions-description">
        I Travelled accross Indonesia, to the beautiful islands as Part of Sony
        Alpha Indonesia's Contest.
      </p>
      <SRLWrapper>
        <div className="portfolio-pictures-row-portrait">
          {pictures.map((picture, index) => {
            return <img key={`sony-alpha-${index}`} src={picture} />;
          })}
        </div>
      </SRLWrapper>
    </div>
  );
};

export default Sony;
